import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import GlobalWebSocketInitializer from 'components/GlobalWebSocketInitializer';
import LogRocketInitializer from 'components/LogRocketInitializer';
import SupportTicketShell from 'components/SupportTicketShell';
import { StoreProvider } from 'contexts/StoreProvider';
import { observer } from 'mobx-react';
import 'primeicons/primeicons.css';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; //theme
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { rootStore } from 'stores/RootStore';
import AppRoutes from 'validations/Navigations';
import './App.css';
import config from './config';

const oktaAuth = new OktaAuth(config.oidc);

function App() {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <StoreProvider store={rootStore}>
          <PrimeReactProvider>
            <LogRocketInitializer />
            <GlobalWebSocketInitializer />
            <SupportTicketShell />
            <AppRoutes />
            <ToastContainer
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              limit={3}
            />
          </PrimeReactProvider>
        </StoreProvider>
      </Security>
    </>
  );
}

export default observer(App);
